<template>
  <div id="AddSemesterDialog">

           <v-list class="pb-0 pt-0 white tileCard mt-3"  two-line >
              <v-list-item  @click="moreInfo(paShadow)"  >


                  <v-list-item-content  >



                          <v-list-item-title class="light-blue--text  text--darken-3 subheading font-weight-medium" >{{paShadow.pa_name}}</v-list-item-title>
                        <v-list-item-subtitle class="  mt-1">Total Hours: <span class="font-weight-medium green--text">{{totalShadowingHours}}</span>

                        </v-list-item-subtitle>




                   </v-list-item-content>


                      <v-list-item-action >

                      <v-btn  icon  :ripple="false" >
                        <v-icon color="grey">mdi-chevron-right</v-icon>
                        </v-btn>



                      </v-list-item-action>






              </v-list-item>
           </v-list>








        <!-- <v-card tile>
          <v-toolbar card  color="blue" dark>
            <v-icon color="white">info</v-icon>
            <v-toolbar-title>{{paShadow.pa_name}}</v-toolbar-title>

            <v-spacer></v-spacer>
            <v-menu bottom right offset-y>


            </v-menu>
          </v-toolbar>
          <v-card-text>


              <v-list >

                <v-list-tile >
                  <v-list-tile-action>
                    <v-icon color="blue">phone</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{paShadow.pa_phone}}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>


                <v-list-tile >
                  <v-list-tile-action>
                    <v-icon color="blue">email</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{paShadow.pa_email}}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>


                <v-list-tile >
                  <v-list-tile-action>
                    <v-icon color="blue">local_hospital</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{paShadow.pa_shadowing_facility}}</v-list-tile-title>
                    <v-list-tile-sub-title>{{paShadow.pa_speciality}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>



          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click.native="InfoPaShadowingDialog = false">Close</v-btn>
        </v-card-actions>
          <div style="flex: 1 1 auto;"></div>
        </v-card> -->

  </div>

</template>

<script>
  export default {
    props: ['paShadow'],
     data() {
      return {
        modal: false,
        alert: false,
        InfoPaShadowingDialog: false,
      }
    },
    methods: {
      moreInfo (paShadow) {
        this.$router.push('/dashboard/pashadowing/pashadow/' + paShadow.id)
      }
    },
    computed : {
      user () {
        return this.$store.getters.user
      },
      totalShadowingHours() {
          return this.paShadow.logged_hours.reduce((sum, loggedHours)=> {
             return sum + parseFloat(loggedHours.shadowing_hours)
        }, 0)
      },
    },
  }
</script>

<style scoped>
.tileCard {
  border-radius: 10px;
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/PaShadowingHours/InfoPaShadowing.vue